import CheckIcon from '@/_application/icons/check-icon';
import cn from 'classnames';
import {ChangeEvent, InputHTMLAttributes} from 'react';

interface CustomCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    checked: boolean;
    label?: string;
    variant?: 'circle' | 'square';
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const CustomCheckbox = ({name, checked, label, variant = 'circle', onChange, ...rest}: CustomCheckboxProps) => {
    return (
        <div className="flex items-center">
            <label
                className={cn('relative flex cursor-pointer items-center p-3', {
                    'rounded-full': variant === 'circle',
                    rounded: variant === 'square',
                })}
                htmlFor={name}>
                <input
                    type="checkbox"
                    checked={checked}
                    className={cn(
                        "before:content[''] border-blue-gray-200 before:bg-blue-gray-500 peer relative h-4 w-4 cursor-pointer appearance-none border outline-none transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-7 before:w-7 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full before:opacity-0 before:transition-opacity checked:border-primary checked:bg-primary checked:before:bg-primary hover:before:opacity-10",
                        {
                            'rounded-full': variant === 'circle',
                            rounded: variant === 'square',
                        },
                    )}
                    aria-label="Checkbox Input"
                    id={name}
                    {...rest}
                    onChange={onChange}
                />
                <span className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100">
                    <CheckIcon className="h-3 w-3 text-white" />
                </span>
            </label>

            {label && (
                <label className="mt-px cursor-pointer select-none text-left text-base text-white" htmlFor={name}>
                    {label}
                </label>
            )}
        </div>
    );
};
